module.exports = __webpack_public_path__ + "static/img/ICON-platinum.1c03f12.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ICON-platinum.png
// module id = Qsu5
// module chunks = 1